package com.gsb.vyapar.bhagya.interactor.view

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.asPaddingValues
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.systemBars
import androidx.compose.material.ModalBottomSheetLayout
import androidx.compose.material.ModalBottomSheetValue
import androidx.compose.material.Scaffold
import androidx.compose.material.rememberModalBottomSheetState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.onSizeChanged
import com.gsb.vyapar.bhagya.interactor.event.UiEvents
import com.gsb.vyapar.bhagya.interactor.uistate.UiState
import com.gsb.vyapar.bhagya.presentation.Screens
import com.gsb.vyapar.bhagya.presentation.bottomsheet.BottomSheets
import com.gsb.vyapar.bhagya.presentation.bottomsheet.util.hideBottomSheet
import com.gsb.vyapar.bhagya.presentation.category.view.AddEditCategoryView
import com.gsb.vyapar.bhagya.presentation.category.view.AddEditSubCategoryView
import com.gsb.vyapar.bhagya.presentation.common.animation.Animate
import com.gsb.vyapar.bhagya.presentation.dialog.view.DialogView
import com.gsb.vyapar.bhagya.presentation.navigation.view.NavigationView
import com.gsb.vyapar.bhagya.presentation.splash.view.SplashView
import com.gsb.vyapar.bhagya.theme.primary
import kotlinx.coroutines.launch

@Composable
fun MainView(uiState: UiState, onTriggerEvent: (UiEvents) -> Unit) {
    Scaffold { paddingValues ->
        Box(Modifier.fillMaxSize().background(color = primary).padding(paddingValues).padding(WindowInsets.systemBars.asPaddingValues()).onSizeChanged {
            onTriggerEvent(UiEvents.Portrait(it.width < it.height))
        }) {
            val state = rememberModalBottomSheetState(ModalBottomSheetValue.Hidden, confirmValueChange = {
                if (it == ModalBottomSheetValue.Hidden) {
                    hideBottomSheet()
                }
                true
            })
            val scope = rememberCoroutineScope()
            ModalBottomSheetLayout(
                sheetState = state,
                sheetContent = {
                    when (uiState.bottomSheetView) {
                        BottomSheets.AddEditCategory -> AddEditCategoryView(uiState, onTriggerEvent)
                        BottomSheets.AddEditSubCategory -> AddEditSubCategoryView(uiState, onTriggerEvent)
                        else -> {}
                    }
                }
            ) {
                Column {
                    when (uiState.mainView) {
                        Screens.Splash -> Animate { SplashView(uiState, onTriggerEvent) }
                        Screens.Navigation -> Animate { NavigationView(uiState, onTriggerEvent) }
                        else -> {}
                    }
                }
                uiState.dialogUiState?.let { Animate { DialogView(it) } }
                uiState.loadingUiState?.let { Animate { DialogView(it) } }
                uiState.errorUiState?.let { Animate { DialogView(it) } }
                uiState.successUiState?.let { Animate { DialogView(it) } }
                uiState.bottomSheetView?.let {
                    if (!state.isVisible) scope.launch { state.show() }
                } ?: run {
                    if (state.isVisible) scope.launch { state.hide() }
                }
            }
        }
    }
}
